module.exports = global["moment"] = require("-!/var/www/html/node_modules/moment/moment.js");


//////////////////
// WEBPACK FOOTER
// ./~/moment/moment.js
// module id = 1
// module chunks = 0